import React from "react";
import { Modal } from 'antd';

const Confirmation = ({
  onClose,
  modalState,
  confirm,
  title,
  message
}) => {
  return (
      <Modal
        title={title}
        visible={modalState}
        onOk={confirm}
        onCancel={onClose}
      >
        <p>{message}</p>
      </Modal>
  );
};

export default Confirmation;
